import { forwardRef, useId, type ReactNode, type SelectHTMLAttributes } from 'react';
import clsx from 'clsx';
import styles from './Select.module.scss';

export interface NebiSelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  error?: string;
  helperText?: string;
  fullWidth?: boolean;
  children: ReactNode;
}

export const Select = forwardRef<HTMLSelectElement, NebiSelectProps>(function Select(
  { label, error, helperText, fullWidth = true, className, id, children, ...rest },
  ref,
) {
  const autoId = useId();
  const selectId = id ?? `nebi-select-${autoId}`;
  const msgId = `${selectId}-msg`;
  const message = error ?? helperText;

  return (
    <div className={clsx(styles.wrapper, fullWidth && styles.fullWidth, className)}>
      {label && (
        <label className={styles.label} htmlFor={selectId}>
          {label}
        </label>
      )}
      <select
        ref={ref}
        id={selectId}
        className={clsx(styles.select, error && styles.invalid)}
        aria-invalid={error ? true : undefined}
        aria-describedby={message ? msgId : undefined}
        {...rest}
      >
        {children}
      </select>
      {message && (
        <span id={msgId} className={clsx(styles.message, error && styles.errorText)}>
          {message}
        </span>
      )}
    </div>
  );
});

export default Select;
